<template>
    <div ref="vsContainer" class="virtual-staging-outer-container-xs" @scroll="scrollPage">
        <section>
            <div
                v-if="selectServiceStyle === 'collapse'"
                class="virtual-staging-select-service-collapse-outer-container-xs"
                @click="expandSelectServiceCollapse"
            >
                <div class="virtual-staging-select-service-collapse-inner-container-xs">
                    <span>Select Service</span>
                    <img src="../assets/expand-icon.svg" alt="" />
                </div>
            </div>
            <select-service
                v-else
                class="positions-absolute"
                current-service="VS"
                :media-details="orderMediaDetailsVS"
                :over-lab-menu="overLabMenu"
                @change-service="selectServiceEvent"
                @collapse-menu="selectServiceStyle = 'collapse'"
            />
        </section>

        <comment-box
            :class="[
                selectServiceStyle === 'collapse'
                    ? 'virtual-staging-comment-box-container-xs'
                    : 'mb-3',
            ]"
            :comments="VSComments"
            :order-media-details="orderMediaDetailsVS"
            :service-price="parseFloat(vsStore.stylesPrice)"
            service-title="Virtual Staging"
            @new-comment="addNewComment"
            @edit-comment="editComment"
            @delete-comment="deleteComment"
        />
        <style-mode-buttons-xs
            v-if="vsMode === 'style'"
            @roomType-modal="showRoomTypeModal = true"
            @styleCategory-modal="showStyleCategoryModal = true"
            @show-switch-mode="showSwitchMode = true"
        />
        <style-category-xs
            v-if="showStyleCategoryModal"
            @select-roomType="showRoomTypes"
            @close-modal="showStyleCategoryModal = false"
        />
        <description-box
            :comments="VSComments"
            :reference-photo="VSReferencePhoto"
            service="VS"
            :has-reference-photo="true"
            @service-description-event="addComment"
            @reference-photo-event="showReferencePhotoModal = true"
        />
        <!-- <comments-menu :comments="VSComments" /> -->
        <!-- <transition>
            <reference-photo
                :reference-photo="VSReferencePhoto"
                service="VS"
                @show-modal="showReferencePhotoModal = true"
            />
        </transition> -->
        <reference-photo-modal
            v-if="showReferencePhotoModal"
            service="VS"
            @close-modal="showReferencePhotoModal = false"
        />

        <!-- <advance-mode-buttons
            v-if="vsMode === 'advance'"
            @select-catalogue-modal="showSelectCatalogesModal = true"
        /> -->
        <room-type-modal-xs v-if="showRoomTypeModal" @close-modal="showRoomTypeModal = false" />

        <!-- <style-mode-output v-if="vsMode === 'style'" />
        <advance-mode-output-xs v-else /> -->

        <!-- <switch-to-advance-modal-xs v-if="showSwitchMode" @close-modal="showSwitchMode = false" /> -->
        <SelectCataloguesModal
            v-if="showSelectCataloguesModal"
            @close-modal="showSelectCataloguesModal = false"
        />
        <save-buttons
            :saving-service="savingService"
            @apply-event="saveChangesButton"
            @select-summary-btn="navigateToProjectSummary"
            @show-modal="showNextServiceModal = true"
        />

        <navigate-to-project-summary
            v-if="showProjectSummaryBottomSheet"
            @save-navigate-project-summary="saveNavigateProjectSummary"
            @close-modal="showProjectSummaryBottomSheet = false"
        />

        <new-service-warning
            v-if="showNewServiceWarning"
            @close-modal="showNewServiceWarning = false"
            @change-service-warning="changeServiceWarningEvent"
        />

        <next-service
            v-if="showNextServiceModal"
            current-service="VS"
            :order-media-details="orderMediaDetailsVS"
            @close-modal="showNextServiceModal = false"
        />
        <div class="notification-container-xs">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SelectService from '../../components/SelectService.vue';
import CommentBox from '../../components/CommentBox.vue';
// import CommentsMenu from '../../components/CommentsMenu.vue';
// import ReferencePhoto from '../../components/ReferencePhoto.vue';
import ReferencePhotoModal from '../../components/ReferencePhotoModal.vue';
import RoomTypeModalXs from '../components/RoomTypeModalXs.vue';
import StyleCategoryXs from '../components/StyleCategoryXs.vue';
// import StyleModeOutput from '../components/StyleModeOutputXs';
import StyleModeButtonsXs from '../components/StyleModeButtonsXs.vue';
import SaveButtons from '../components/SaveButtons.vue';
// import SwitchToAdvanceModalXs from '../components/SwitchToAdvanceModalXs.vue';
// import AdvanceModeButtons from '../components/AdvanceModeButtons.vue';
import SelectCataloguesModal from '../components/SelectCataloguesModal.vue';
// import AdvanceModeOutputXs from '../components/advanceModeOutputXs.vue';
import NewServiceWarning from '../../components/NewServiceWarning.vue';
import NavigateToProjectSummary from '../../components/NavigateToProjectSummary.vue';
// import baseApiAddress from '@/axios.config';
import NextService from '../../components/NextService.vue';
// import Lottie from 'vue-lottie';
import animationData from '@/assets/new-loading.json';
import DescriptionBox from '@/components/comment-box/components/CommentBoxXl.vue';
import virtualStagingMixin from '../mixins/virtualStagingMixin';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        Notification,
        CommentBox,
        SelectService,
        // CommentsMenu,
        // ReferencePhoto,
        ReferencePhotoModal,
        RoomTypeModalXs,
        StyleCategoryXs,
        // StyleModeOutput,
        StyleModeButtonsXs,
        SaveButtons,
        // SwitchToAdvanceModalXs,
        // AdvanceModeButtons,
        SelectCataloguesModal,
        // AdvanceModeOutputXs,
        NewServiceWarning,
        NavigateToProjectSummary,
        NextService,
        DescriptionBox,
        // Lottie,
    },
    mixins: [virtualStagingMixin],
    data() {
        return {
            showReferencePhotoModal: false,
            showRoomTypeModal: false,
            showStyleCategoryModal: false,
            showSwitchMode: false,
            showSelectCataloguesModal: false,
            showNavToPS: false,
            selectedService: '',
            showNewServiceWarning: false,
            showNextServiceModal: false,
            selectServiceStyle: 'expand',
            defaultOptions: { animationData },
            overLabMenu: false,
        };
    },
    computed: {
        ...mapGetters([
            'VSComments',
            'orderMediaDetailsVS',
            'VSReferencePhoto',
            'selectedRoomTypes',
            'vsMode',
            'vsHasChanged',
            'vsLoadingXS',
        ]),
        ...mapState(['vsStore']),
        serviceData() {
            const {
                vsMode,
                selectedRoomTypes,
                selectedStyles,
                selectedSingleCatalogues,
                selectedMultipleCatalogues,
            } = this.vsStore;
            let single = [],
                multiple = [],
                vsServices = [],
                styles = [],
                roomTypesId = [];

            selectedRoomTypes.map((item) => {
                roomTypesId.push(item.id);
            });
            selectedStyles.map((item) => {
                styles.push({
                    _id: item._id,
                    output: item.numOfOutput,
                    VS_Type: 'style',
                    style_id: item.id,
                    roomTypes: roomTypesId,
                });
            });
            selectedSingleCatalogues.map((item) => {
                single.push({
                    _id: item._id,
                    delete: item.delete ? true : '',
                    output: 1,
                    VS_Type: 'single',
                    catalogs: [item.id],
                });
            });
            for (let i = 0; i < selectedMultipleCatalogues.length; i++) {
                let cataloguesArray = [];
                let deleteMulti = '';

                if (
                    selectedMultipleCatalogues[i].length === 1 &&
                    Object.keys(selectedMultipleCatalogues[i][0]).length === 1
                ) {
                    multiple.push({
                        delete: true,
                        _id: selectedMultipleCatalogues[i][0]._id,
                    });
                } else {
                    selectedMultipleCatalogues[i].map((item) => {
                        cataloguesArray.push(item.id);
                    });

                    multiple.push({
                        _id:
                            selectedMultipleCatalogues[i][0]._id &&
                            selectedMultipleCatalogues[i][0]._id.length > 0
                                ? selectedMultipleCatalogues[i][0]._id
                                : '',
                        output: 1,
                        delete: deleteMulti,
                        VS_Type: 'multi',
                        catalogs: cataloguesArray,
                    });
                }

                cataloguesArray = [];
            }
            if (vsMode === 'style') {
                styles.map((style) => {
                    vsServices.push(style);
                });
            } else {
                single.map((item) => {
                    vsServices.push(item);
                });
                multiple.map((item) => {
                    vsServices.push(item);
                });
            }

            const dataVS = {
                order_id: this.orderMediaDetailsVS.order_id,
                media_details_id: this.orderMediaDetailsVS._id,
                type: 'VS',
                service_details: {
                    comments: this.VSComments,
                    references: this.VSReferencePhoto,
                },
                services: vsServices,
            };
            return dataVS;
        },

        // advancePric() {
        //     const services_prices = JSON.parse(sessionStorage.getItem('services_prices'));
        //     const { firstPrice } = services_prices.VS;
        //     const { multiplePrice, singlePrice } = this.vsStore;
        //     if (singlePrice > 0 || multiplePrice > 0) {
        //         return multiplePrice + singlePrice + firstPrice;
        //     }
        //     return 0;
        // },
    },
    created() {
        this.$store.commit('setHeaderTitle', this.selectedImageName());
    },
    methods: {
        scrollPage() {
            this.selectServiceStyle = 'collapse';
        },
        expandSelectServiceCollapse() {
            this.selectServiceStyle = 'expand';
            this.overLabMenu = true;
        },
        selectedImageName() {
            return this.orderMediaDetailsVS.mediaName.length > 15
                ? `${this.orderMediaDetailsVS.mediaName.substring(0, 15)}...`
                : this.orderMediaDetailsVS.mediaName;
        },
        addNewComment(comment) {
            this.$store.commit('addToVSComments', comment);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        editComment(id, text) {
            const dispatchData = {
                id,
                text,
            };
            this.$store.commit('editVSComments', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        deleteComment(id) {
            this.$store.commit('deleteIEComments', id);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        showRoomTypes() {
            this.showStyleCategoryModal = false;
            this.showRoomTypeModal = true;
        },

        //The function used in the services change modal
        changeServiceWarningEvent(type) {
            if (type === 'cancel') {
                this.changeRoute('change-service');
                return;
            }
            if (type === 'save') {
                this.saveVsServiceChanges('change-service');
            }
        },

        async selectServiceEvent(selectedService) {
            this.nextServiceTitle = selectedService;
            if (this.vsHasChanged) {
                this.showNewServiceWarning = true;
                return;
            }
            this.changeRoute('change-service');
        },
        changeRoute(type) {
            if (type === 'project-summary') {
                return this.$router.push('/project-overview');
            }
            if (type === 'change-service') {
                this.$router.push(
                    `/${this.nextServiceTitle}/image_id=${this.orderMediaDetailsVS._id}`
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/VirtualStagingXs';
.notification {
    &-container-xs {
        width: 330px;
        position: fixed;
        bottom: 20px;
        right: 10px;
        z-index: 100;
    }
}
</style>
